"use client";

import { ArrowRight, MapPin } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheSanctuary() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const details = [{
    label: "ADDRESS",
    value: "Poseidonos Ave, Paphos 8042"
  }, {
    label: "LOCATION",
    value: "BLOCK B / SHOP 4 / PAPHOS"
  }, {
    label: "CONTACT",
    value: "+357 94 043514"
  }];
  const openingHours = [{
    day: "MONDAY",
    hours: "10AM – 7PM"
  }, {
    day: "TUESDAY",
    hours: "10AM – 7PM"
  }, {
    day: "WEDNESDAY",
    hours: "10AM – 7PM"
  }, {
    day: "THURSDAY",
    hours: "10AM – 7PM"
  }, {
    day: "FRIDAY",
    hours: "10AM – 7PM"
  }, {
    day: "SATURDAY",
    hours: "10AM – 7PM"
  }, {
    day: "SUNDAY",
    hours: "11AM – 5PM"
  }];
  return <section data-section-id="2609" id="the-sanctuary" className="bg-background text-foreground pt-24 md:pt-32 lg:pt-[180px] pb-20 md:pb-24 lg:pb-[120px] px-6 md:px-10 lg:px-16">
      <div ref={ref} className={`mx-auto max-w-[1440px] transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
          <div className="lg:col-span-5 flex flex-col">
            <div className="flex items-center gap-3 mb-12 md:mb-16">
              <span className="h-px w-8 bg-primary" />
              <span className="font-mono text-xs tracking-[0.2em] text-primary uppercase">
                CYPRUS / § 8042
              </span>
            </div>

            <h1 className="font-default text-5xl md:text-6xl lg:text-7xl leading-[0.95] tracking-tight mb-12 md:mb-16">
              <span className="block">FIND /</span>
              <span className="block italic text-primary">HARD ROCK TATTOO</span>
            </h1>

            <div className="flex flex-col border-t border-border">
              {details.map((row, i) => <div key={i} data-index={i} className="grid grid-cols-[110px_1fr] md:grid-cols-[140px_1fr] gap-4 md:gap-6 items-baseline py-5 border-b border-border">
                  <span className="font-mono text-[10px] md:text-xs tracking-[0.18em] text-muted-foreground uppercase">
                    {row.label}
                  </span>
                  <span className="font-default text-[15px] md:text-[18px] tracking-[0.04em] uppercase font-medium">
                    {row.value}
                  </span>
                </div>)}
            </div>

            <div className="mt-12 md:mt-16">
              <div className="mb-4">
                <span className="font-mono text-[10px] md:text-xs tracking-[0.2em] text-primary uppercase">
                  OPENING HOURS
                </span>
              </div>
              <div className="flex flex-col border-t border-border">
                {openingHours.map((item, i) => <div key={i} data-index={i} className="grid grid-cols-2 gap-4 items-baseline py-3 border-b border-border">
                    <span className="font-mono text-[10px] md:text-xs tracking-[0.18em] text-primary uppercase">
                      {item.day}
                    </span>
                    <span className="font-default text-[14px] md:text-[16px] tracking-[0.04em] uppercase text-right">
                      {item.hours}
                    </span>
                  </div>)}
              </div>
            </div>

            <div className="mt-12 md:mt-16">
              <Button asChild size="lg" className="h-14 px-8 bg-primary text-primary-foreground hover:bg-primary/90 rounded-md font-default text-xs tracking-[0.2em] uppercase shadow-lg">
                <Link to="https://wa.me/35794043514">
                  INQUIRE VIA WHATSAPP
                  <ArrowRight className="ml-1 size-4" />
                </Link>
              </Button>
            </div>
          </div>

          <div className="lg:col-span-7 flex flex-col">
            <div className="relative w-full h-[480px] md:h-[640px] lg:h-[760px] border border-border bg-card overflow-hidden shadow-2xl">
              <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3262.045678901234!2d32.4145678!3d34.7589012!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14e706f8f8f8f8f8%3A0x8f8f8f8f8f8f8f8f!2sPoseidonos%20Ave%2C%20Paphos%208042%2C%20Cyprus!5e0!3m2!1sen!2scy!4v1710000000000!5m2!1sen!2scy" className="absolute inset-0 w-full h-full border-0 grayscale invert contrast-125 opacity-80" allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="Hard Rock Tattoo Location" />

              <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 pointer-events-none">
                <div className="relative flex items-center justify-center">
                  <span className="absolute inline-flex h-24 w-24 rounded-md bg-primary opacity-20 animate-ping" style={{
                  animationDuration: "3s"
                }} />
                  <span className="absolute inline-flex h-16 w-16 rounded-md bg-primary opacity-30 animate-ping" style={{
                  animationDuration: "2s"
                }} />
                  <span className="absolute inline-flex h-10 w-10 rounded-md bg-primary/40 blur-md" />

                  <div className="relative flex items-center justify-center h-12 w-12 bg-primary shadow-2xl rotate-45 rounded-md">
                    <MapPin className="size-5 text-primary-foreground -rotate-45" strokeWidth={2.5} />
                  </div>
                </div>
              </div>

              <div className="absolute top-4 left-4 font-mono text-[10px] tracking-[0.2em] text-muted-foreground/70 uppercase pointer-events-none">
                34.77° N / 32.42° E
              </div>
              <div className="absolute top-4 right-4 font-mono text-[10px] tracking-[0.2em] text-muted-foreground/70 uppercase pointer-events-none">
                ZOOM · 18.2
              </div>
              <div className="absolute bottom-4 left-4 font-mono text-[10px] tracking-[0.2em] text-muted-foreground/70 uppercase pointer-events-none">
                HARD ROCK / STUDIO
              </div>
              <div className="absolute bottom-4 right-4 flex items-center gap-2 pointer-events-none">
                <span className="h-1.5 w-1.5 bg-primary animate-pulse" />
                <span className="font-mono text-[10px] tracking-[0.2em] text-primary uppercase">
                  OPEN
                </span>
              </div>
            </div>

            <div className="mt-5 flex items-center gap-3">
              <span className="h-px flex-1 bg-border" />
              <p className="font-mono text-[10px] md:text-xs tracking-[0.22em] text-muted-foreground uppercase text-center">
                PRIVATE STUDIO · BLOCK B / DISCRETION OBSERVED
              </p>
              <span className="h-px flex-1 bg-border" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}